const UPDATE_RFP_CLIENT_ONE_FILE_ROOT_VIEW_REQUEST = 'UPDATE_RFP_CLIENT_ONE_FILE_ROOT_VIEW_REQUEST';
const UPDATE_RFP_CLIENT_ONE_FILE_ALL_FORM = 'UPDATE_RFP_CLIENT_ONE_FILE_ALL_FORM';
const RESET_RFP_CLIENT_ONE_FILE_ALL_FORM = 'RESET_RFP_CLIENT_ONE_FILE_ALL_FORM';
export const initialState = {
    viewRequests: null,
};
/**
 * 閲覧申請の値を更新
 * @param values
 */
export const updateRfpCliFileViewRequestAction = (values) => ({
    payload: values,
    type: UPDATE_RFP_CLIENT_ONE_FILE_ROOT_VIEW_REQUEST,
});
/**
 * Formの値を更新
 * @param values
 */
export const updateRfpCliFileFormAction = (values) => ({
    payload: values,
    type: UPDATE_RFP_CLIENT_ONE_FILE_ALL_FORM,
});
/**
 * Formの値を初期化
 */
export const resetRfpCliFileFormAction = () => ({
    type: RESET_RFP_CLIENT_ONE_FILE_ALL_FORM,
});
/**
 * reducer処理
 * @param state
 * @param action
 */
export const reducer = (state, action) => {
    switch (action.type) {
        // 閲覧申請一覧を設定
        case UPDATE_RFP_CLIENT_ONE_FILE_ROOT_VIEW_REQUEST:
            return Object.assign(Object.assign({}, state), { viewRequests: action.payload });
        // フォームの値を設定
        case UPDATE_RFP_CLIENT_ONE_FILE_ALL_FORM:
            return Object.assign(Object.assign({}, state), { formValues: action.payload });
        // フォームの値をリセット
        case RESET_RFP_CLIENT_ONE_FILE_ALL_FORM:
            return Object.assign(Object.assign({}, state), { formValues: undefined });
        default:
            return state;
    }
};
